module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "body-bgx  pb-5 mt-5 pt-5"
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "60%",
      "color": "#000"
    },
    attrs: {
      "src": "/static/images/emoticon-down.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("404")]), _vm._v(" "), _c('h5', [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("The Page you are looking for does not exists or an error occured.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Head over to the home page")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbdbdc2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFoundView.vue
// module id = 1722
// module chunks = 40